const LinkedinLike = ({ color }: any) => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10 5V9H4.34C4.05009 8.99672 3.76294 9.0565 3.49843 9.17522C3.23392 9.29393 2.99838 9.46873 2.80814 9.68751C2.6179 9.90629 2.4775 10.1638 2.39666 10.4423C2.31582 10.7207 2.29649 11.0134 2.34 11.3L3.72 20.3C3.79232 20.7769 4.03456 21.2116 4.40209 21.524C4.76962 21.8364 5.23767 22.0055 5.72 22H17H20C20.5304 22 21.0391 21.7893 21.4142 21.4142C21.7893 21.0391 22 20.5304 22 20V13C22 12.4696 21.7893 11.9609 21.4142 11.5858C21.0391 11.2107 20.5304 11 20 11H17L13 2C12.2044 2 11.4413 2.31607 10.8787 2.87868C10.3161 3.44129 10 4.20435 10 5Z'
        stroke='#666666'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default LinkedinLike
